import { Component, input } from '@angular/core';
import { ENativeBottomNavbarItem, INativeBottomNavbarItem } from 'src/models/app.model';
import { AccountRoute, CollaboratorRoute, DashboardRoute, InvestmentsListRoute, MoneyAndTransactionsRoute } from 'src/models/routes.model';

@Component({
  selector: 'liberro-basic-layout-native-bottom-bar',
  standalone: false,
  templateUrl: './basic-layout-native-bottom-bar.component.html',
  styleUrls: ['./basic-layout-native-bottom-bar.component.less'],
})
export class BasicLayoutNativeBottomBarComponent {
  public activeNativeBottomNavbarItem = input.required<ENativeBottomNavbarItem | null>();

  public items: INativeBottomNavbarItem[] = [
    {
      label: 'layout.nativeBottomBar.summary',
      icon: 'native-summary.svg',
      type: ENativeBottomNavbarItem.SUMMARY,
      route: `/${DashboardRoute.DASHBOARD}`,
    },
    {
      label: 'layout.nativeBottomBar.investments',
      icon: 'native-investments.svg',
      type: ENativeBottomNavbarItem.INVESTMENTS,
      route: `/${InvestmentsListRoute.INVESTMENTS}`,
    },
    {
      label: 'layout.nativeBottomBar.money',
      icon: 'native-money.svg',
      type: ENativeBottomNavbarItem.MONEY,
      route: `/${MoneyAndTransactionsRoute.MONEY_TRANSACTIONS}`,
    },
    {
      label: 'layout.nativeBottomBar.myConsultant',
      icon: 'native-my-consultant.svg',
      type: ENativeBottomNavbarItem.MY_CONSULTANT,
      route: `/${CollaboratorRoute.COLLABORATOR}`
    },
    {
      label: 'layout.nativeBottomBar.myAccount',
      icon: 'native-my-account.svg',
      type: ENativeBottomNavbarItem.MY_ACCOUNT,
      route: `/${AccountRoute.ACCOUNT}`,
    }
  ];
}
